import { useEffect, useState } from 'react';
import { LoginThemeType } from '@/app/models/LoginThemeType';

export const useLoginTheme = (theme: LoginThemeType = LoginThemeType.LIGHT) => {
  const [systemDark, setSystemDark] = useState(() => globalThis.matchMedia('(prefers-color-scheme: dark)').matches);
  useEffect(() => {
    const media = globalThis.matchMedia('(prefers-color-scheme: dark)');
    const updateTheme = () => setSystemDark(media.matches);
    media.addEventListener('change', updateTheme);
    return () => media.removeEventListener('change', updateTheme);
  }, []);
  const isDark = theme === LoginThemeType.DARK || (theme === LoginThemeType.SYSTEM && systemDark);
  return isDark ? 'dark' : 'light';
};
